<template>
  <v-text-field
    class="ma-0 pa-0"
    :value="text"
    :placeholder="placeholder"
    prepend-inner-icon="mdi-magnify"
    outlined
    clearable
    @click:clear="clearable()"
    @keydown="keyDown()"
    @keyup="keyUp()"
    @input="updateValue($event)"
  ></v-text-field>
</template>
<script>
export default {
  props: {
    textQuery: {
      type: String,
    },
    codQuery: {
      type: String,
    },
    placeholder: {
      type: String,
    },
  },

  data() {
    return {
      text: "",
      typingTimer: "",
    };
  },

  methods: {
    updateValue(value) {
      this.text = value?.toUpperCase();
    },
    clearable() {
      this.value = "";
      this.$emit("textValue", {
        [`${this.textQuery}`]: undefined,
        [`${this.codQuery}`]: undefined,
      });
    },

    keyDown() {
      clearTimeout(this.typingTimer);
    },

    keyUp() {
      clearTimeout(this.typingTimer);

      if (this.text == "") {
        this.clearable();
        return 0;
      }

      this.typingTimer = setTimeout(() => {
        this.typeValue();
      }, 1000);
    },

    typeValue() {
      if (/^[0-9]+$/.test(this.text)) {
        this.$emit("textValue", {
          [`${this.codQuery}`]: `%${this.text?.toString()?.toUpperCase()}%`,
          [`${this.textQuery}`]: undefined,
        });
        return 0;
      }
      this.$emit("textValue", {
        [`${this.textQuery}`]: `%${this.text?.toUpperCase()}%`,
        [`${this.codQuery}`]: undefined,
      });
    },
  },
};
</script>

<style scoped>
/deep/.v-input__slot {
  background-color: #eef2f7 !important;
  margin: 0 !important;
}
</style>
